module.exports = __webpack_public_path__ + "img/WM22_400x416@2x.32ed0362.jpg";